// extracted by mini-css-extract-plugin
export default {"-large":"hN5pBZdrJw4gxBhlruPr","tabs":"UEd8EfUO8KCbX9nEJHNc"};